import { Link } from 'react-router-dom';
import { USER_TYPE_CONFIG, REGISTERABLE_USER_TYPES, type UserType } from '@/shared/types/users.types';

export default function RegisterSection() {
    return (
        <section className="py-20 bg-gray-50" id="inscription">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-14">
                    <p className="text-sm font-semibold text-teal-600 uppercase tracking-wider mb-2">
                        Rejoindre ONAPILA
                    </p>
                    <h2 className="text-4xl font-bold text-gray-900 mb-4">
                        Choisissez votre profil
                    </h2>
                    <p className="text-lg text-gray-500 max-w-2xl mx-auto">
                        Inscription disponible pour les clients et les livreurs.
                        Déjà inscrit ?{' '}
                        <Link to="/login" className="text-teal-600 hover:underline font-medium">
                            Connectez-vous ici
                        </Link>.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
                    {REGISTERABLE_USER_TYPES.map((type: UserType) => {
                        const cfg = USER_TYPE_CONFIG[type];

                        return (
                            <Link
                                key={type}
                                to={`/register/${type}`}
                                className="group bg-white rounded-2xl p-6 border border-gray-200
                                    hover:border-teal-300 hover:shadow-md transition-all duration-200 flex flex-col"
                            >
                                <div className={`w-12 h-12 bg-${cfg.color}-100 rounded-xl flex items-center justify-center mb-4`}>
                                    <i className={`${cfg.icon} text-${cfg.color}-600 text-xl`} />
                                </div>
                                <h4 className="font-semibold text-gray-900 mb-2">{cfg.label}</h4>
                                <p className="text-sm text-gray-500 flex-1">{cfg.description}</p>
                                <div className="mt-4 flex items-center text-teal-600 text-sm font-semibold gap-1">
                                    S'inscrire
                                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
